import { useContext } from 'react';
import { RequestExecutorsContext, RequestExecutorsContextType } from '../../contexts/RequestExecutorsContext';

export function useRequestExecutorsContext(): RequestExecutorsContextType {
    return useContext(RequestExecutorsContext);
}
